import React from 'react';
import Draggable from 'react-draggable';
import { getTouchPosition } from '../utils/TransformToolUtils';
import dragManager from '../utils/DragManager';
import storeManager from '../../store/StoreManager';
import createShapes from '../utils/CreateShapes';
import properties from '../../constants/Properties';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import videoUtils from '../../components/utils/VideoUtils';
import { changeBackgroundContent } from '../../actions/CurrentSlideActions';
import hoverManager from '../utils/HoverManager';
import { showAudioAlert } from '../../actions/MenuActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';

export const MediaImagesItemRenderer = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0,
            element: undefined,
            scrollPosition: 0
        };
    },
    componentDidMount() {
        this.initElements();
    },
    onImageLoaded(e) {
        var imageWidth = e.currentTarget.width;
        var imageHeight = e.currentTarget.height;
        const gap = 3;
        var width = 100;
        var height = width * 3/4;

        width = width - gap;
        height = height - gap;

        if (imageWidth > width) {
            var image = e.currentTarget;
            var newHeight = width * (imageHeight / imageWidth);

            image.style.position = 'absolute';
            image.style.left = '0px';
            image.style.width = width + 'px';
            image.style.height = newHeight + 'px';
            image.style.top = (height - newHeight) / 2 + 'px';
        }
    },
    onVideoLoaded(e) {
        var imageWidth = e.currentTarget.videoWidth;
        var imageHeight = e.currentTarget.videoHeight;
        const gap = 3;
        var width = 100;
        var height = width * 3/4;

        width = width - gap;
        height = height - gap;

        if (imageWidth > imageHeight && imageWidth > width) {
            var image = e.currentTarget;
            var newHeight = width * (imageHeight / imageWidth);

            image.style.position = 'absolute';
            image.style.left = '0px';
            image.style.width = width + 'px';
            image.style.height = newHeight + 'px';
            image.style.top = (height - newHeight) / 2 + 'px';
        }
    },
    initElements() {
        const gap = 3;
        var width = 100;
        var height = width * 3/4 + 15;

        const itemRendererStyle = {
            position: 'relative',
            width: width,
            height: height,
            paddingTop: gap,
            paddingLeft: gap,
            display: 'inline-block',
            textAlign: 'center',
            cursor: '-webkit-grab'
        };

        width = width - gap;
        height =  height - gap;

        const wrapperStyle = {
            position: 'absolute',
            width: width,
            height: height,
            background: 'aliceblue',
            textAlign: 'center',
            top: 0,
            display: 'block'
        };

        const imageStyle = {
            height: height
        };

        let frameDisplayState;

        if (this.state.isOver == true)
            frameDisplayState = 'block';
        else
            frameDisplayState = 'none';

        const boderWidth = 2;

        const frameStyle = {
            width: width - 2 * boderWidth,
            height: height - 2 * boderWidth,
            borderWidth: boderWidth,
            borderStyle: 'solid',
            borderColor: properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR,
            position: 'absolute',
            top: 0,
            display: frameDisplayState
        };

        const draggableStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: 2,
            background: 'red',
            opacity: 0,
            display: 'block'
        };

        if (!this.props.item)
            return;

        var element1;
        var thumb;

        const  src = this.props.item.thumb;
        // var src = 'https://stage.creaza.com/file/ci/58153319/thumb/aaa';

        if (this.props.item.status == 'preparing' || this.props.item.status == 'corrupt') {
            const loaderStyle = {
                position: 'absolute',
                top: 20,
                left: 35,
                color: 'black'
            };

            if (this.props.item.href && this.props.item.href.length > 0) {
                if (this.props.isVideo) {
                    if (!platformDetection.isIOS() && this.props.item.status == 'preparing')
                        thumb = <video src={this.props.item.href} style={imageStyle} onLoadedData={this.onVideoLoaded}/>;
                    else
                        thumb = <i style={loaderStyle} className='fa fa-spinner fa-pulse fa-2x'/>;
                } else
                    thumb = <img alt='' aria-hidden='true' src={this.props.item.href} style={imageStyle} onLoad={this.onImageLoaded}/>;
            } else {
                thumb = <i style={loaderStyle} className='fa fa-spinner fa-pulse fa-2x'/>;
            }
        } else
            thumb = <img alt='' aria-hidden='true' src={src} style={imageStyle} onLoad={this.onImageLoaded}/>;

        if (platformDetection.isIOS() == true) {
            element1 =
                <div style={wrapperStyle}>
                    {thumb}
                    <div style={frameStyle}/>
                </div>;
        } else {
            element1 = thumb;
        }

        var element2 =
        <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
            <span style={draggableStyle}/>
        </Draggable>;

        var uploadButton;

        if (this.props.item && this.props.item.isUploadButton) {
            var uploadItemRendererStyle = {
                position: 'relative',
                width: width,
                paddingTop: gap,
                paddingLeft: gap,
                display: 'inline-block',
                textAlign: 'center'
            };

            if (platformDetection.isIOS())
                uploadItemRendererStyle.height = 60;

            if (this.props.length < 2) {
                uploadItemRendererStyle.height = 60;
                uploadItemRendererStyle.paddingTop = 7;
            }

            var wrapperUploadButtonStyle = {
                position: 'absolute',
                width: width,
                height: height,
                textAlign: 'center',
                display: 'block',
                top: 0
            };

            const uploadIconStyle = {
                position: 'absolute',
                top: 4,
                left: 21,
                color: '#2DE102'
            };

            if (platformDetection.isIOS()) {
                uploadButton =
                    <div style={uploadItemRendererStyle} id='uploadButton' onMouseDown={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                        <div style={wrapperUploadButtonStyle}>
                            <i style={uploadIconStyle} className="fa fa-plus-circle fa-4x"></i>
                        </div>
                    </div>;
            } else {
                uploadItemRendererStyle.width = itemRendererStyle.width;
                uploadItemRendererStyle.height = itemRendererStyle.height;
                uploadItemRendererStyle.paddingTop = gap;
                uploadItemRendererStyle.paddingLeft = gap;
                uploadItemRendererStyle.paddingRight = 0;
                uploadItemRendererStyle.paddingBottom = 0;
                uploadItemRendererStyle.boxSizing = 'initial';
                uploadItemRendererStyle.fontSize = 'initial';
                uploadItemRendererStyle.borderStyle = 'none';
                uploadItemRendererStyle.background = 'none';
                uploadItemRendererStyle.top = -4;
                wrapperUploadButtonStyle.top = 0;

                uploadButton =
                    <button aria-label={locales.getCaption('UploadHover', 'myFiles')} style={uploadItemRendererStyle} id='uploadButton' onClick={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                        <span style={wrapperUploadButtonStyle}>
                            <i style={uploadIconStyle} className="fa fa-plus-circle fa-4x"></i>
                        </span>
                    </button>;
            }
        }

        var fontStyle = {
            fontSize: 10,
            height: 15,
            width: width - 6,
            paddingLeft: 3,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            position: 'absolute',
            bottom: 0,
            left: 0
        };

        if (platformDetection.isIOS() == true)
            fontStyle.bottom = 8;

        var fontElement =
            <span style={fontStyle}>{this.getTitle()}</span>;

        this.setState({
            itemRendererStyle,
            wrapperStyle,
            element1,
            element2,
            uploadButton,
            fontElement
        });
    },
    getTitle() {
        if (this.props.item.title)
            return this.props.item.title;

        var title = '';

        if (this.props.item.noBackground == true)
            title = this.props.item.title;

        return title;
    },
    onMouseIn () {
        if (this.isDisabled()) {
            this.setState({
                isMouseIn: true
            });

            return;
        }

        this.setState({
            isOver: true
        });

        if (this.props.item.isUploadButton) {
            var button = document.getElementById('uploadButton');
            hoverManager.show(button, 'uploadButton');
        }
    },
    onMouseOut () {
        hoverManager.hide();

        if (this.isDisabled()) {
            this.setState({
                isMouseIn: false
            });

            return;
        }

        this.setState({
            isOver: false
        });
    },
    changeFocusToShapeMenuButton() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var shapeMenuButton = document.getElementById('shapeMenuButton');

            if (shapeMenuButton)
                shapeMenuButton.focus();
        }.bind(this), 300);
    },
    createShape (topLeftPosition) {
        const dispatch = storeManager.getStore().dispatch;

        if (this.props.isVideo) {
            if (createShapes.useVideoAsBackground)
                this.setVideoAsBackground(this.props.item, dispatch);
            else
                createShapes.createVideo(dispatch, this.props.item, topLeftPosition);
        } else {
            if (createShapes.useImageAsBackground)
                this.setImageAsBackground(this.props.item, dispatch);
            else
                createShapes.createImage(dispatch, this.props.item, topLeftPosition);

            this.changeFocusToShapeMenuButton();
        }
    },
    setVideoAsBackground(item, dispatch) {
        videoUtils.updateContentFromCurrentSlide();

        let newContent = {};
        newContent.logicalName = item.logicalName;
        newContent.href = item.href;
        newContent.moods = [];
        newContent.hotSpot = '';
        newContent.frameLabel = '';

        newContent.isVideo = true;
        newContent.volume = 0.5;
        newContent.inPoint = undefined;
        newContent.outPoint = undefined;

        if (item.contentItemId > 0)
            newContent.contentItemId = item.contentItemId;

        videoUtils.changeVideoBackground = true;

        dispatch(changeBackgroundContent(newContent));
        createShapes.updateThumbnail(dispatch);
        dispatch(showAudioAlert(3));
    },
    setImageAsBackground(item, dispatch) {
        var imageObj = new Image();
        var self = this;

        imageObj.onload = function (e) {
            var orgWidth = e.target.width;
            var orgHeight = e.target.height;

            self.changeBackgroundProperties(item, dispatch, orgWidth, orgHeight);
        };

        imageObj.src = videoUtils.checkCacheBreaker(item.href);
    },
    changeBackgroundProperties(item, dispatch, orgWidth, orgHeight) {
        let newContent = {};
        newContent.logicalName = item.logicalName;
        newContent.href = item.href;
        newContent.moods = [];
        newContent.hotSpot = '';
        newContent.frameLabel = '';
        newContent.orgWidth = orgWidth;
        newContent.orgHeight = orgHeight;

        newContent.isVideo = false;
        newContent.volume = 0.5;
        newContent.inPoint = undefined;
        newContent.outPoint = undefined;

        if (item.contentItemId > 0)
            newContent.contentItemId = item.contentItemId;

        dispatch(changeBackgroundContent(newContent));
        createShapes.updateThumbnail(dispatch);
        audioEditorUtils.addActionToHistory();

        saveManager.isContentChanged(true);
    },
    onUpload(e) {
        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled())
            return;

        window.parent.postMessage('openUploader', '*');
    },
    rejectMouseDownEvent(e) {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseDownTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseDownEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();
        mouseUtils.isDragEnd = false;

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    isDisabled() {
        if (!this.props.isVideo && videoUtils.showVideoEditor())
            return true;
        else
            return false;
    },
    onClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        mouseUtils.isDragEnd = false;

        this.createShape();
    },
    rejectMouseUpEvent(e) {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseUpTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseUpEvent(e))
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (mouseUtils.isDragEnd == true) {
            mouseUtils.isDragEnd = true;
            return;
        }

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.createShape();
    },
    onDragStart(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        mouseUtils.mouseDownTime = new Date().getTime();
        mouseUtils.isDragEnd = false;

        const clone = this.refs.itemRenderer;

        dragManager.prepareClone(clone, this.createShape, getTouchPosition(e));
    },
    onDragMove(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        dragManager.onDragMove(coreEvent.lastX, coreEvent.lastY);
    },
    onDragEnd(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        mouseUtils.isDragEnd = true;

        dragManager.onDragEnd(coreEvent.lastX, coreEvent.lastY);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.element1 != nextState.element1 || this.state.isOver != nextState.isOver || this.props.isVideo != newProps.isVideo || this.state.isMouseIn != nextState.isMouseIn)
            return true;
        else
            return false;
    },
    render() {
        if (this.state ==  undefined || this.state.element1 == undefined)
            return (<div/>);

        if (this.props.item && this.props.item.isUploadButton) {
            return (this.state.uploadButton);
        }

        var thumbnailElement = this.state.element1;

        if (platformDetection.isIOS() == true) {
            return (
                <div ref='itemRenderer' id={'MediaImagesItemRenderer_' + Math.random()} style={this.state.itemRendererStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp}>
                    {thumbnailElement}
                    {this.state.fontElement}
                    {this.state.element2}
                </div>
            );
        } else {
            var width = 100;
            var height = width * 3/4 + 15;
            let frameDisplayState;

            if (this.state.isOver == true)
                frameDisplayState = 'block';
            else
                frameDisplayState = 'none';

            const boderWidth = 2;

            const frameStyle = {
                width: width - 3 * boderWidth,
                height: height - 3 * boderWidth,
                borderWidth: boderWidth,
                borderStyle: 'solid',
                borderColor: properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR,
                position: 'absolute',
                top: 0,
                display: frameDisplayState
            };

            var style = Object.assign({}, this.state.itemRendererStyle);

            if (this.isDisabled())
                style.cursor = 'default';
            else
                style.cursor = '-webkit-grab';

            style.margin = 0;
            style.paddingRight = 0;
            style.paddingBottom = 0;
            style.boxSizing = 'initial';
            style.fontSize = 'initial';
            style.borderStyle = 'none';
            style.background = 'none';

            return (
                <button aria-label={this.getTitle()} ref='itemRenderer' id={'MediaImagesItemRenderer_' + Math.random()} style={style} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp}>
                    <span style={this.state.wrapperStyle}>
                        {thumbnailElement}
                        {this.state.fontElement}
                        <span style={frameStyle}/>
                    </span>;
                    {this.state.element2}
                </button>
            );
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/MediaImagesItemRenderer.js
 **/